import { render, staticRenderFns } from "./goodsEva.vue?vue&type=template&id=f15c4e88&scoped=true&"
import script from "./goodsEva.vue?vue&type=script&lang=js&"
export * from "./goodsEva.vue?vue&type=script&lang=js&"
import style0 from "./goodsEva.vue?vue&type=style&index=0&id=f15c4e88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15c4e88",
  null
  
)

export default component.exports